/* Main  -------------------------------------------------------------------------- */

.mainBody {
  padding: 19px 18px 140px;
  max-width: 600px;
  margin: 0 auto;
}

.loginVariant {
  min-height: auto;
  padding-top: 40px;
  padding-bottom: 40px;
}

@media screen and (min-width: 1025px) {
  .mainBody {
    padding-top: 110px;
    min-height: calc(100vh - 58px);
    padding-bottom: 40px;
  }

  .loginVariant {
    min-height: auto;
    padding-top: 40px;
    padding-bottom: 40px;
  }
}
